import type { ProjectOption } from '@/api/v4/projects.api';

export const mapProjectOptions = (projects: ProjectOption[]) =>
  projects.map(project => ({
    value: project.id,
    label: project.name,
    createdFor: project.team ? project.team.id : null,
  }));
